import React from "react";
import {
  I2cSelect,
  I2cMenuItem,
  I2cDatePicker,
  I2cButton,
} from "@webcomponents/i2cwebcomponents/dist/react";
import "./FiltersDrawerContent.scss";
import { getFormattedDate } from "../../Utils/stringUtls";

export const formatDate = (dateString) => {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const date = new Date(dateString);
  const month = months[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();

  return `${month} ${day},  ${year}`;
};

export const FiltersDrawerContent = ({
  onClose = () => {},
  handleConfirmation = () => {},
  defaultValues = {
    role: "",
    from: "",
    to: "",
  },
}) => {
  const [filterDataInternal, setFilterDataInternal] =
    React.useState(defaultValues);

  return (
    <div>
      <div className="sales-filters-container">
        <div className="filters-header-description">
          Apply filters for page content.
        </div>
        <I2cSelect
          className="request-status-select"
          label="Filter By User Type"
          placeholder="User Type"
          size="large"
          value={filterDataInternal.role}
          onI2cChange={(e) =>
            setFilterDataInternal({
              ...filterDataInternal,
              role: e.target.value ?? "sales",
            })
          }
        >
          <I2cMenuItem value="admin">Admin</I2cMenuItem>
          <I2cMenuItem value="client">Client</I2cMenuItem>
          <I2cMenuItem value="sales">Sales</I2cMenuItem>
          <I2cMenuItem value="manager">Manager</I2cMenuItem>
        </I2cSelect>
        <div
          style={{
            display: "flex",
            gap: "var(--i2c-spacing-4)",
            flexWrap: "wrap",
            marginBottom: "var(--i2c-spacing-6)",
          }}
        >
          <I2cDatePicker
            dateFormat="F d, Y"
            label="Filter By Date" 
            rotateIcon
            hoist
            size="large"
            suffix='<i2c-icon name="linear-calendar-2" slot="suffix" class="suffix-iCon4"></i2c-icon>'
            allowInput={false}
            // [new Date(filterDataInternal.from), new Date(filterDataInternal.to)]
            defaultDate={[
              formatDate(filterDataInternal.from),
              formatDate(filterDataInternal.to),
            ]}
            onI2cDateApply={(e) => {
              const from = getFormattedDate(
                e.target.appliedDate[0]?.toDateString(),
              );
              const to = getFormattedDate(
                e.target.appliedDate[1]?.toDateString(),
              );
              setFilterDataInternal({
                ...filterDataInternal,
                from: from ?? "",
                to: to ?? "",
              });
            }}
            screen="mobile"
          ></I2cDatePicker>
        </div>

        <div className="filter-drawer-footer">
          <I2cButton
            slot="footer"
            variant="secondary gray"
            onClick={() => {
              setFilterDataInternal({
                role: "",
                from: "",
                to: "",
              });
              handleConfirmation({
                role: "",
                from: "",
                to: "",
              });
              onClose();
            }}
            disabled={false}
            className="btn"
            size={"medium"}
          >
            Cancel
          </I2cButton>
          <I2cButton
            onClick={() => handleConfirmation(filterDataInternal)}
            slot="footer"
            variant={"primary"}
            disabled={false}
            className="btn"
            size={"medium"}
          >
            Confirm
          </I2cButton>
        </div>
      </div>
    </div>
  );
};
